export default __webpack_public_path__ + "static/media/b9.beefda89.jpg";